export class Address {
  constructor(
    public cep?: string,
    public city?: string,
    public complement?: string,
    public country?: string,
    public district?: string,
    public id?: string,
    public number?: string,
    public state?: string,
    public street?: string,
  ) {}
}

export class ViaCEP {
  constructor(
    public cep?: string,
    public logradouro?: string,
    public complemento?: string,
    public bairro?: string,
    public localidade?: string,
    public uf?: string,
    public ibge?: string,
    public gia?: string,
    public ddd?: string,
    public siafi?: string
  ) {}
}


